import {React , useEffect} from "react";
import PageHeader from "../components/headers/PageHeader";
import Banner from "../components/banner/Banner";
import WhatsappBanner from "../components/banner/WhatsappBanner";
import PortfolioCard from "../components/cards/PortfolioCard";


const FlyerDesign = () => {
  useEffect(() => {
    window.scrollTo(0,0)
  },[])
  const designs = [
    {
      id: 1,
      image: "assests/images/portfolio/flyer-design/sokari-1.png",
    },
    {
      id: 2,
      image: "assests/images/portfolio/flyer-design/sokari-2.png",
    },
    {
      id: 3,
      image: "assests/images/portfolio/flyer-design/feternity.jpg",
    },
    {
      id: 4,
      image: "assests/images/portfolio/flyer-design/sahan.jpg",
    },
    {
      id: 5,image: "assests/images/portfolio/flyer-design/flyer-1.jpg",
    },
    {
      id: 6,
      image: "assests/images/portfolio/flyer-design/pmc-1.webp",
    },
    {
      id: 7,
      image: "assests/images/portfolio/flyer-design/bce-3.webp",
    },
    {
      id: 8,
      image: "assests/images/portfolio/flyer-design/raveen-ict.jpg",
    },
    {
      id: 9,
      image: "assests/images/portfolio/flyer-design/t-shirt.jpg",
    },
    {
      id: 10,
      image: "assests/images/portfolio/flyer-design/sc-1.webp",
    },
    {
      id: 11,
      image: "assests/images/portfolio/flyer-design/sc-2.webp",
    },
    {
      id: 12,
      image: "assests/images/portfolio/flyer-design/sc-4.webp",
    },
    {
      id: 13,
      image: "assests/images/portfolio/flyer-design/bce-1.webp",
    },
    {
      id: 14,
      image: "assests/images/portfolio/flyer-design/bce-2.webp",
    },
    {
      id: 15,
      image: "assests/images/portfolio/flyer-design/smp-1.webp",
    },
    {
      id: 16,
      image: "assests/images/portfolio/flyer-design/tg-1.jpg",
    },
    {
      id: 17,
      image: "assests/images/portfolio/flyer-design/tgt-2.webp",
    },
    {
      id: 18,
      image: "assests/images/portfolio/flyer-design/tgt-3.webp",
    },
    {
      id: 19,
      image: "assests/images/portfolio/flyer-design/artical.png",
    },
    {
      id: 20,
      image: "assests/images/portfolio/flyer-design/sc-3.webp",
    },
    {
      id: 21,
      image: "assests/images/portfolio/flyer-design/smp-2.webp",
    },
    {
      id: 22,
      image: "assests/images/portfolio/flyer-design/bce-4.webp",
    },
    {
      id: 23,
      image: "assests/images/portfolio/flyer-design/bce-5.jpg",
    },
    {
      id: 24,
      image: "assests/images/portfolio/flyer-design/bce-6.webp",
    },
    {
      id: 25,
      image: "assests/images/portfolio/flyer-design/bce-7.webp",
    },
    {
      id: 26,
      image: "assests/images/portfolio/flyer-design/bce-8.webp",
    },
    {
      id: 27,
      image: "assests/images/portfolio/flyer-design/bce-9.webp",
    },
    {
      id: 28,
      image: "assests/images/portfolio/flyer-design/sc-5.jpg",
    },
    {
      id: 27,
      image: "assests/images/portfolio/flyer-design/bce-10.webp",
    },
    {
      id: 27,
      image: "assests/images/portfolio/flyer-design/bce-11.webp",
    },
  ];
  
  return (
    <div>
      <PageHeader heading="Flyer Design" />{" "}
      <div className="flex justify-center pt-8">
        <Banner
          url="contact"
          text="Get More Details"
          btn="Contact Me"
          subtext="I’m always open to discussing product design work or partnerships."
        />
      </div>
      <div className="flex justify-center">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 gap-2 md:gap-8 max-w-[1140px] 2xl:max-w-[1140px] justify-center text-justify">
          {designs.map((service, i) => (
            <PortfolioCard
              name={service.name}
              tech={service.tech}
              des={service.des}
              image={service.image}
              readmore={service.readmore}
              heightMain="[380px]"
              height="[360px]"
            />
          ))}
        </div>
      </div>
      <div className="flex justify-center py-8">
        <WhatsappBanner/>
        </div>
      {/* <NumberSpringBanner /> */}
      {/* <TwoLineTitle
        main="Web Hosting"
        des="Powerful and easy to control cPanel to allow our customers to take the wheel. You take the lead when it comes to what you need."
      />
      <PricingTableHosting /> */}
    </div>
  );
};

export default FlyerDesign;
